import React from "react";
import { Avatar, Box, Typography } from "@mui/material";
import { Menu, MenuItem, Sidebar } from 'react-pro-sidebar';
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import GroupOutlinedIcon from '@mui/icons-material/GroupOutlined';
import SourceOutlinedIcon from '@mui/icons-material/SourceOutlined';
import { useTheme } from "@mui/material";
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import Logo from "../../assets/images/logo.svg";

import BarChartOutlinedIcon from '@mui/icons-material/BarChartOutlined';

import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import QuizOutlinedIcon from '@mui/icons-material/QuizOutlined';

import ExitToAppOutlinedIcon from '@mui/icons-material/ExitToAppOutlined';
import { useDispatch } from 'react-redux';
import { logout, selectAuth } from "../../redux/slice/authSlice"

import "./components.css";
import logos from "../../assets/images/mainlogo.svg";
import { NavLink, useParams } from "react-router-dom";

import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Button from '@mui/material/Button';
import useEncryption from "../../services/useEncryption";


export default function DoctorSidebar({ isOpen }) {
  const userRole = useSelector((state) => state.auth.role);
  const { userProfile, role } = useSelector(selectAuth); 
  const { encryptData, decryptData } = useEncryption();
  

  const theme = useTheme();
  const { id } = useParams();

  const encryptedId = encodeURIComponent(decodeURIComponent(id));
  const dispatch = useDispatch();

  const handleSignOut = () => {
    sessionStorage.removeItem('token');
    dispatch(logout());


  };


  const [expanded, setExpanded] = React.useState('panel1');

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };
  const handleToggleBodyClass = () => {
    document.body.classList.remove('sidebarOpen');
  };

  const capitalizeFirstLetter = (str) => {
    return str.replace(/\b\w/g, (char) => char.toUpperCase());
  };


  return (

    <Sidebar className="sidebar">
      <div className="mainlogo">
        <img src={logos} alt="logo" />
        <button onClick={handleToggleBodyClass} className="btnsClesedSidebar"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
  <path d="M7.50001 14.5L11 11M11 11L14.5 7.49999M11 11L14.5 14.5M11 11L7.50001 7.49999M20.5 11C20.5 16.2467 16.2467 20.5 11 20.5C5.75329 20.5 1.5 16.2467 1.5 11C1.5 5.75329 5.75329 1.5 11 1.5C16.2467 1.5 20.5 5.75329 20.5 11Z" stroke="#35353A" strokeWidth="1.25" strokeLinecap="round"/>
</svg></button>
      </div>

      <div className="navigationMenu">

        <nav id="sidebar" className="accordianmenu">
          <Accordion className="menuItems" expanded={expanded === 'panel1'} onChange={handleChange('panel1')} defaultExpanded>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1-content"
              id="panel1-header"
            >
                 <NavLink  className="sideNavigation" to={`/${userRole}/${encryptedId}`}><svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                <path d="M19 7.42749H10M19 12.4275H10M19 17.4275H10M7 7.42749C7 7.97977 6.55228 8.42749 6 8.42749C5.44772 8.42749 5 7.97977 5 7.42749C5 6.87521 5.44772 6.42749 6 6.42749C6.55228 6.42749 7 6.87521 7 7.42749ZM7 12.4275C7 12.9798 6.55228 13.4275 6 13.4275C5.44772 13.4275 5 12.9798 5 12.4275C5 11.8752 5.44772 11.4275 6 11.4275C6.55228 11.4275 7 11.8752 7 12.4275ZM7 17.4275C7 17.9798 6.55228 18.4275 6 18.4275C5.44772 18.4275 5 17.9798 5 17.4275C5 16.8752 5.44772 16.4275 6 16.4275C6.55228 16.4275 7 16.8752 7 17.4275Z" stroke="black" strokeLinecap="round" />
              </svg><span>Leads</span></NavLink>
            </AccordionSummary>
            <AccordionDetails>
              <NavLink onClick={handleToggleBodyClass} className="sideNavigation" to={`/${userRole}/${encryptedId}`}><span>List View</span></NavLink>
              <NavLink onClick={handleToggleBodyClass} className="sideNavigation" to={`/${userRole}/pipelineview/${encryptedId}`}><span>Pipeline View</span></NavLink>
            </AccordionDetails>
          </Accordion>
        {/* {(userRole === "doctor" || userRole === "provider" || userRole === "location") && (
          <Accordion  className="menuItems" expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
            <AccordionSummary
     
              aria-controls="panel2-content"
              id="panel2-header"
            >
                <NavLink onClick={handleToggleBodyClass} className="sideNavigation" to={`/${userRole}/reviewsection/${encryptedId}`}><svg xmlns="http://www.w3.org/2000/svg" width="21" height="25" viewBox="0 0 21 25" fill="none">
                <path d="M2.03538 12.9275L1.67217 13.1512C1.26478 13.4022 0.771512 12.9926 0.943272 12.546L1.45072 11.2267C1.53198 11.0154 1.46117 10.7759 1.27809 10.6428L0.244022 9.89088C-0.147648 9.60608 0.0538017 8.98648 0.538072 8.98648H1.66881C1.88701 8.98648 2.08001 8.84497 2.14565 8.63687L2.52336 7.43932C2.67038 6.97319 3.33003 6.97319 3.47705 7.43932L3.85476 8.63687C3.92039 8.84497 4.1134 8.98648 4.3316 8.98648H5.26229C5.7642 8.98648 5.95317 9.64331 5.528 9.91003L5.5002 9.92747M12.5002 9.92747L12.4724 9.91003C12.0472 9.64331 12.2362 8.98648 12.7381 8.98648H13.6688C13.887 8.98648 14.08 8.84497 14.1456 8.63687L14.5234 7.43932C14.6704 6.97319 15.33 6.97319 15.477 7.43932L15.8548 8.63687C15.9204 8.84497 16.1134 8.98648 16.3316 8.98648H17.4623C17.9466 8.98648 18.1481 9.60608 17.7564 9.89087L16.7223 10.6428C16.5392 10.7759 16.4684 11.0154 16.5497 11.2267L17.0571 12.546C17.2289 12.9926 16.7356 13.4022 16.3282 13.1512L15.965 12.9275M11.3933 16.0554L11.9718 17.5593C12.24 18.2567 11.4349 18.8746 10.8306 18.4351L9.5884 17.5316C9.2377 17.2766 8.7627 17.2766 8.412 17.5316L7.1698 18.4351C6.56551 18.8746 5.76041 18.2567 6.02864 17.5593L6.60709 16.0554C6.76961 15.6329 6.62799 15.1538 6.26184 14.8876L4.86593 13.8726C4.27842 13.4454 4.5806 12.516 5.307 12.516H6.81982C7.2562 12.516 7.6422 12.233 7.7735 11.8168L8.2849 10.1952C8.5055 9.49605 9.4949 9.49605 9.7155 10.1952L10.2269 11.8168C10.3582 12.233 10.7442 12.516 11.1806 12.516H12.6934C13.4198 12.516 13.722 13.4454 13.1345 13.8726L11.7386 14.8876C11.3724 15.1538 11.2308 15.6329 11.3933 16.0554Z" stroke="#3D3E3F" strokeWidth="0.9" strokeLinecap="round" />
              </svg><span>Review</span></NavLink> 
            </AccordionSummary>
          </Accordion>
        )} */}
                {(userRole === "doctor" || userRole === "provider" || userRole === "location") && (
          <Accordion  className="menuItems" expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel3-content"
              id="panel3-header"
            >

              <NavLink  className="sideNavigation" ><svg xmlns="http://www.w3.org/2000/svg" width="22" height="25" viewBox="0 0 22 25" fill="none">
                <path d="M17.7668 7.5957C17.5706 7.27789 17.2484 7.04515 16.8709 6.95024C16.4925 6.85532 16.0903 6.90524 15.7517 7.08875C15.189 7.39317 14.5106 7.39282 13.9483 7.08784L13.3655 6.77182C12.838 6.48575 12.5095 5.93382 12.5095 5.33374C12.5095 4.56874 11.851 3.92749 11.0367 3.92749H8.9632C8.1489 3.92749 7.49037 4.56874 7.49037 5.33374C7.49037 5.93386 7.16193 6.48585 6.63449 6.77213L6.05245 7.08806C5.49008 7.3933 4.81152 7.39356 4.24892 7.08875C3.91032 6.90524 3.50728 6.85531 3.12898 6.95024C2.75141 7.04516 2.4293 7.27789 2.23301 7.5957L1.19772 9.28039C1.0022 9.5982 0.948999 9.97648 1.05014 10.3309C1.15127 10.6859 1.39848 10.9883 1.73709 11.1718C2.29109 11.4725 2.63616 12.0523 2.63635 12.6826L2.63649 13.1724C2.63668 13.8027 2.29179 14.3825 1.73784 14.6832C1.39923 14.8674 1.15126 15.1691 1.05014 15.5234C0.949009 15.8785 1.00219 16.2568 1.19772 16.5746L2.23451 18.2593C2.43002 18.5771 2.75215 18.8098 3.12973 18.9048C3.50805 18.9997 3.91032 18.9498 4.24967 18.7662C4.81235 18.4618 5.4907 18.4622 6.05306 18.7672L6.63371 19.0821C7.16159 19.3684 7.49036 19.9207 7.49036 20.5213C7.49036 21.2863 8.1488 21.9275 8.9632 21.9275H11.0361C11.8511 21.9275 12.5089 21.2863 12.5089 20.5213C12.5093 19.9207 12.8384 19.3685 13.3663 19.0822L13.9476 18.7671C14.51 18.4621 15.1884 18.4618 15.7511 18.7662C16.0904 18.9497 16.4927 18.9997 16.8703 18.9048C17.2486 18.8098 17.5707 18.5771 17.7662 18.2593L18.8023 16.5746C18.9978 16.2568 19.051 15.8785 18.9499 15.5241C18.8487 15.1691 18.6015 14.8667 18.2629 14.6832C17.7089 14.3825 17.364 13.8027 17.364 13.1724V12.6826C17.364 12.0523 17.7089 11.4725 18.2629 11.1718C18.6015 10.9876 18.8487 10.6859 18.9499 10.3315C19.051 9.97645 18.9978 9.59818 18.8023 9.28037L17.7668 7.5957Z" stroke="#3D3E3F" strokeLinecap="round" />
                <path d="M13 12.9275C13 14.5844 11.6569 15.9275 10 15.9275C8.3431 15.9275 7 14.5844 7 12.9275C7 11.2706 8.3431 9.92749 10 9.92749C11.6569 9.92749 13 11.2706 13 12.9275Z" stroke="#3D3E3F" strokeLinecap="round" />
              </svg><span>Settings</span></NavLink>
            </AccordionSummary>
            <AccordionDetails>
              <NavLink onClick={handleToggleBodyClass} className="sideNavigation" to={`/${userRole}/managestaff/${encryptedId}`}><span>Manage Team</span></NavLink>
              <NavLink onClick={handleToggleBodyClass} className="sideNavigation" to={`/${userRole}/logs/${encryptedId}`}><span>Logs</span></NavLink>
              {/* <NavLink onClick={handleToggleBodyClass} className="sideNavigation" to={`/${userRole}/trans-details/${encryptedId}`}><span>Transaction History</span></NavLink> */}
              {/* <NavLink onClick={handleToggleBodyClass} className="sideNavigation" to={`/${userRole}/notificaton/${encryptedId}`}><span>Notificaton</span></NavLink> */}
              {userRole !== "location" && (
              <NavLink
                onClick={handleToggleBodyClass}
                className="sideNavigation"
                to={`/${userRole}/notificaton/${encryptedId}`}
              >
                <span>Notification</span>
              </NavLink>
            )}
            </AccordionDetails>

          </Accordion>

        )}


        {(userRole === "doctor" || userRole === "provider" || userRole === "location") && (
          <Accordion  className="menuItems" expanded={expanded === 'panel4'} onChange={handleChange('panel4')}>
            <AccordionSummary
     
              aria-controls="panel2-content"
              id="panel2-header"
            >
                <NavLink onClick={handleToggleBodyClass} className="sideNavigation" to={`/${userRole}/location-details/${encryptedId}`}><svg xmlns="http://www.w3.org/2000/svg" width="21" height="25" viewBox="0 0 21 25" fill="none">
                <path d="M2.03538 12.9275L1.67217 13.1512C1.26478 13.4022 0.771512 12.9926 0.943272 12.546L1.45072 11.2267C1.53198 11.0154 1.46117 10.7759 1.27809 10.6428L0.244022 9.89088C-0.147648 9.60608 0.0538017 8.98648 0.538072 8.98648H1.66881C1.88701 8.98648 2.08001 8.84497 2.14565 8.63687L2.52336 7.43932C2.67038 6.97319 3.33003 6.97319 3.47705 7.43932L3.85476 8.63687C3.92039 8.84497 4.1134 8.98648 4.3316 8.98648H5.26229C5.7642 8.98648 5.95317 9.64331 5.528 9.91003L5.5002 9.92747M12.5002 9.92747L12.4724 9.91003C12.0472 9.64331 12.2362 8.98648 12.7381 8.98648H13.6688C13.887 8.98648 14.08 8.84497 14.1456 8.63687L14.5234 7.43932C14.6704 6.97319 15.33 6.97319 15.477 7.43932L15.8548 8.63687C15.9204 8.84497 16.1134 8.98648 16.3316 8.98648H17.4623C17.9466 8.98648 18.1481 9.60608 17.7564 9.89087L16.7223 10.6428C16.5392 10.7759 16.4684 11.0154 16.5497 11.2267L17.0571 12.546C17.2289 12.9926 16.7356 13.4022 16.3282 13.1512L15.965 12.9275M11.3933 16.0554L11.9718 17.5593C12.24 18.2567 11.4349 18.8746 10.8306 18.4351L9.5884 17.5316C9.2377 17.2766 8.7627 17.2766 8.412 17.5316L7.1698 18.4351C6.56551 18.8746 5.76041 18.2567 6.02864 17.5593L6.60709 16.0554C6.76961 15.6329 6.62799 15.1538 6.26184 14.8876L4.86593 13.8726C4.27842 13.4454 4.5806 12.516 5.307 12.516H6.81982C7.2562 12.516 7.6422 12.233 7.7735 11.8168L8.2849 10.1952C8.5055 9.49605 9.4949 9.49605 9.7155 10.1952L10.2269 11.8168C10.3582 12.233 10.7442 12.516 11.1806 12.516H12.6934C13.4198 12.516 13.722 13.4454 13.1345 13.8726L11.7386 14.8876C11.3724 15.1538 11.2308 15.6329 11.3933 16.0554Z" stroke="#3D3E3F" strokeWidth="0.9" strokeLinecap="round" />
              </svg><span>Location</span></NavLink> 
            </AccordionSummary>
          </Accordion>
        )}
 
        </nav>
        

      </div>
      <div className="sidebar-bottom-items">
          <p className="name-col"> 
            {capitalizeFirstLetter(decryptData(userProfile)?.firstName || '')}{" "} 
            {capitalizeFirstLetter(decryptData(userProfile)?.lastName || '')}
          </p>
          <p className="title-col"> 
          {capitalizeFirstLetter(
            role === 'location' ? 'Admin' : role === 'provider' ? 'Location' : role || ''
          )}</p>
          <p className="title-col">{decryptData(userProfile)?.organizationName || ''}</p>
        </div>
      


    </Sidebar>
  );
}